import { insuranceBaseModel } from './crud';
import { useFetchInsurancePayers } from './useFetchInsurancePayers';
import { useFetchInsuranceVerificationManyHook } from './useFetchInsuranceVerificationMany';
import { useUploadInsuranceCard } from './useUploadInsuranceCard';
import { useVerifyInsurance } from './useVerifyInsurance';

export * from './types';

export const useInsurancesById = insuranceBaseModel.fetchById();
export const useInsurancesByIds = insuranceBaseModel.fetchByIds();
export const useInsurancesMany = insuranceBaseModel.fetchMany();
export const useInsurancesCount = insuranceBaseModel.count();
export const useInsurancesManyInfiniteQuery =
  insuranceBaseModel.fetchPaginated();
export const useInsurancesUpdateOne = insuranceBaseModel.edit();
export const useInsurancesCreateOne = insuranceBaseModel.create();
export const useInsurancesRemoveOne = insuranceBaseModel.delete();
export const useInsurancesRemoveByIds = insuranceBaseModel.deleteByIds();

export const useInsurancesByIdV2 = insuranceBaseModel.fetchByIdV2();
export const useInsurancesByIdsV2 = insuranceBaseModel.fetchByIdsV2();
export const useInsurancesManyV2 = insuranceBaseModel.fetchManyV2();
export const useInsurancesCountV2 = insuranceBaseModel.countV2();
export const useInsurancesManyInfiniteQueryV2 =
  insuranceBaseModel.fetchPaginatedV2();
export const useInsurancesUpdateOneV2 = insuranceBaseModel.editV2();
export const useInsurancesCreateOneV2 = insuranceBaseModel.createV2();
export const useInsurancesRemoveOneV2 = insuranceBaseModel.deleteV2();
export const useInsurancesRemoveByIdsV2 = insuranceBaseModel.deleteByIdsV2();

export const useFetchInsuranceVerificationMany =
  useFetchInsuranceVerificationManyHook;
export const useInsuranceVerificationMany =
  useFetchInsuranceVerificationManyHook;
export const useInsurancePayers = useFetchInsurancePayers;
export const useInsuranceVerify = () => useVerifyInsurance;
export const useInsuranceUpload = () => useUploadInsuranceCard;

// New names based on Mongoose queries
export const useInsuranceById = insuranceBaseModel.fetchById();
export const useInsuranceByIds = insuranceBaseModel.fetchByIds();
export const useInsuranceMany = insuranceBaseModel.fetchMany();
export const useInsuranceCount = insuranceBaseModel.count();
export const useInsurancePagination = insuranceBaseModel.fetchPaginated();
export const useInsuranceUpdateOne = insuranceBaseModel.edit();
export const useInsuranceCreateOne = insuranceBaseModel.create();
export const useInsuranceRemoveOne = insuranceBaseModel.delete();
export const useInsuranceRemoveByIds = insuranceBaseModel.deleteByIds();

export const useInsuranceByIdV2 = insuranceBaseModel.fetchByIdV2();
export const useInsuranceByIdsV2 = insuranceBaseModel.fetchByIdsV2();
export const useInsuranceManyV2 = insuranceBaseModel.fetchManyV2();
export const useInsuranceCountV2 = insuranceBaseModel.countV2();
export const useInsurancePaginationV2 = insuranceBaseModel.fetchPaginatedV2();
export const useInsuranceUpdateOneV2 = insuranceBaseModel.editV2();
export const useInsuranceCreateOneV2 = insuranceBaseModel.createV2();
export const useInsuranceRemoveOneV2 = insuranceBaseModel.deleteV2();
export const useInsuranceRemoveByIdsV2 = insuranceBaseModel.deleteByIdsV2();
